<template>
  <div>
    <v-dialog v-model="incidentReportDialog" persistent max-width="800px">
      <template v-slot:activator="{ attrs }">
        <p
          id="incidentReportForm"
          v-bind="attrs"
          @click="openIncidentReportDialog"
        ></p>
      </template>
      <v-card v-if="objForm !== null">
        <v-card-title>
          <span class="text-h5">Add/Edit Report</span>
        </v-card-title>
        <v-form
          ref="incidentReportRef"
          @submit.prevent="saveIncidentReport"
          :disabled="loading"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan *
                  </p>
                  <v-autocomplete
                    v-model="objForm.company"
                    :items="dropdown.company"
                    :rules="rules.companyRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    :disabled="data != null"
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Lokasi Insiden *
                  </p>
                  <!-- <v-text-field
                    v-model="objForm.incident_location"
                    :rules="rules.locationRules"
                    dense
                    outlined
                    style="height: 45px"
                  /> -->
                  <v-autocomplete
                    v-model="objForm.incident_location"
                    :items="dropdown.area"
                    :rules="rules.locationRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl & Waktu Isiden *
                  </p>
                  <v-text-field
                    v-model="objForm.incident_date_time"
                    :rules="rules.incidentDateRules"
                    type="datetime-local"
                    name="datetime-local"
                    :min="data != null ? getMinDate() + 'T00:00:00' : null"
                    :max="data != null ? getMaxDate() + 'T23:59:59' : null"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <!-- <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Penyebab
                  </p>
                  <v-text-field
                    v-model="objForm.cause"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col> -->
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Insiden Dilaporkan
                  </p>
                  <v-text-field
                    v-model="objForm.reported_date"
                    type="date"
                    name="date"
                    :min="data != null ? getMinDate() : null"
                    :max="data != null ? getMaxDate() : null"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="6"></v-col>

                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kronologi Kejadian *
                  </p>
                  <v-textarea
                    v-model="objForm.chronology"
                    :rules="rules.chronologyRules"
                    :auto-grow="true"
                    rows="3"
                    outlined
                    clear-icon="mdi-close-circle"
                  ></v-textarea>
                </v-col>
                <v-col
                  cols="4"
                  class="d-flex flex-column"
                  style="position: relative; top: -30px"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Rincian Data Saksi & Korban
                    <span style="font-size: 10px">(min 1)</span>
                  </p>
                  <v-btn
                    color="blue darken-1"
                    type="button"
                    small
                    class="white--text"
                    @click="openPersonInvolveDialog"
                    :loading="loading"
                    style="width: 160px"
                  >
                    + Saksi/Korban
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex flex-column"
                  style="position: relative; top: -30px"
                >
                  <v-data-table
                    mobile-breakpoint="0"
                    fixed-header
                    height="30vh"
                    :items="objForm.person_involve"
                    :headers="objPersonHeaders"
                    :items-per-page="10"
                    class="elevation-1 mx-auto"
                    hide-default-footer
                  >
                    <template v-slot:[`item.name`]="{ item }">
                      <div
                        style="
                          width: 120px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.name }}
                      </div>
                    </template>
                    <template v-slot:[`item.birth_date`]="{ item }">
                      <div
                        style="
                          width: 70px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.birth_date }}
                      </div>
                    </template>
                    <template v-slot:[`item.gender`]="{ item }">
                      <div
                        style="
                          width: 70px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.gender != null ? item.gender.name : '-' }}
                      </div>
                    </template>
                    <template v-slot:[`item.no_identitas`]="{ item }">
                      <div
                        style="
                          width: 70px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.no_identitas }}
                      </div>
                    </template>
                    <template v-slot:[`item.person_type`]="{ item }">
                      <div
                        style="
                          width: 70px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{
                          item.person_type != null ? item.person_type.name : '-'
                        }}
                      </div>
                    </template>
                    <template v-slot:[`item.engagement_type`]="{ item }">
                      <div
                        style="
                          width: 80px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{
                          item.engagement_type != null
                            ? item.engagement_type.name
                            : '-'
                        }}
                      </div>
                    </template>
                    <template v-slot:[`item.employee_leader`]="{ item }">
                      <div
                        style="
                          width: 120px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{
                          item.employee_leader != null
                            ? item.employee_leader.name
                            : '-'
                        }}
                      </div>
                    </template>
                    <template v-slot:[`item.injured_category`]="{ item }">
                      <div
                        style="
                          width: 80px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{
                          item.injured_category != null
                            ? item.injured_category.name
                            : '-'
                        }}
                      </div>
                    </template>
                    <template v-slot:[`item.injured_body_part_id`]="{ item }">
                      <div
                        class="d-flex justify-start align-center"
                        style="
                          min-width: 150px;
                          height: 50px;
                          font-size: 12px;
                          padding: 2px;
                          overflow: auto;
                        "
                      >
                        <v-chip
                          v-for="(obj, idx) in item.injured_body_part_id"
                          :key="idx"
                          label
                          outlined
                          small
                          style="
                            position: relative;
                            margin-right: 5px;
                            padding: 0 3px;
                            cursor: pointer;
                            border: 1px solid rgba(0, 0, 0, 0.5);
                          "
                        >
                          {{ getBodyPartName(obj) }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.machine_used`]="{ item }">
                      <div
                        style="
                          width: 80px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.machine_used }}
                      </div>
                    </template>
                    <template v-slot:[`item.amount_loss`]="{ item }">
                      <div
                        style="
                          width: 60px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.amount_loss }}
                      </div>
                    </template>
                    <template v-slot:[`item.rehabilitation_days`]="{ item }">
                      <div
                        style="
                          width: 60px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                        "
                      >
                        {{ item.rehabilitation_days }} Hari
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <div
                        style="
                          width: 30px;
                          font-size: 12px;
                          padding: 0;
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                        "
                      >
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="error"
                              @click.stop="deletePersonInvolve(item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="closeIncidentReportDialog"
              :loading="loading"
            >
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit" :loading="loading">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <PersonInvolveForm
      ref="personInvolveRef"
      @savePersonInvolve="savePersonInvolve"
      :dropdownData="dropdown"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../../services/buildType'
export default {
  name: 'FormIncidentReport',
  props: ['dropdown', 'data', 'param'],
  components: {
    PersonInvolveForm: () => import('./PersonInvolveForm.vue')
  },
  data() {
    return {
      dssApi: buildType.apiURL('dss'),
      loading: false,
      incidentReportDialog: false,
      objForm: null,
      personInvolveForm: null,
      rules: {
        companyRules: [],
        locationRules: [],
        incidentDateRules: [],
        chronologyRules: []
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    objPersonHeaders() {
      const arrHeaders = [
        {
          text: '',
          value: 'action'
        },
        {
          text: 'Nama',
          value: 'name'
        },
        {
          text: 'Tgl. Lahir',
          value: 'birth_date'
        },
        {
          text: 'Jenis Kelamin',
          value: 'gender'
        },
        {
          text: 'No. KTP',
          value: 'no_identitas'
        },
        {
          text: 'Tipe',
          value: 'person_type'
        },
        {
          text: 'Keterlibatan',
          value: 'engagement_type'
        },
        {
          text: 'Kategori',
          value: 'injured_category'
        },
        {
          text: 'Bagian Cidera',
          value: 'injured_body_part_id'
        },
        {
          text: 'Mesin Digunakan',
          value: 'machine_used'
        },
        {
          text: 'Kerugian',
          value: 'amount_loss'
        },
        {
          text: 'Rehab',
          value: 'rehabilitation_days'
        },
        {
          text: 'Perusahaan',
          value: 'company_name'
        },
        {
          text: 'Department',
          value: 'department_name'
        },
        {
          text: 'Atasan',
          value: 'employee_leader_name'
        }
      ]
      return arrHeaders
    }
  },
  watch: {},
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pInputType,
      pInputAtt,
      yesBtn,
      noBtn,
      pText
    ) {
      const title =
        pInputType === 'file'
          ? 'Upload bukti approvement pada kolom dibawah'
          : ''

      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            input: pInputType !== undefined ? pInputType : null,
            inputLabel: pInputType !== undefined ? title : null,
            inputAttributes: pInputAtt !== undefined ? pInputAtt : null,
            confirmButtonText: yesBtn || 'Yes',
            cancelButtonText: noBtn || 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    openIncidentReportDialog() {
      const form = {
        act: 'add_batch',
        incident_location: null,
        reported_date: null,
        incident_date_time: null,
        chronology: null,
        cause: null,
        person_involve: []
      }
      if (this.data != null) {
        Object.assign(form, { company: this.data.company })
      } else {
        const xFindCompany = this.dropdown.company.find(
          ({ id }) => id == this.param.company_id
        )
        Object.assign(form, {
          company: xFindCompany != undefined ? xFindCompany : null
          // company: {
          //   id: Number(this.getUserProfile.employee.company.plant_id),
          //   name: this.getUserProfile.employee.company.name
          // }
        })
      }
      this.objForm = form
      setTimeout(() => {
        // this.startWatcher()
        this.incidentReportDialog = true
      }, 500)
    },
    clickOutside() {
      this.closeIncidentReportDialog()
    },
    closeIncidentReportDialog() {
      this.incidentReportDialog = false
      setTimeout(() => {
        this.objForm = null
      }, 200)
    },
    saveIncidentReport() {
      this.rules.companyRules = [(v) => !!v || 'Kolom company wajib di isii']
      this.rules.locationRules = [
        (v) => !!v || 'Kolom lokasi insiden wajib di isii'
      ]
      this.rules.incidentDateRules = [
        (v) => !!v || 'Kolom tanggal insiden wajib di isii'
      ]
      this.rules.chronologyRules = [
        (v) => !!v || 'Kolom kronologi wajib di isii'
      ]

      const self = this
      setTimeout(function () {
        if (self.$refs.incidentReportRef.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const xArryPerson = []
      // const date = new Date(this.objForm.incident_date)
      // const local = date.toLocaleString('id')
      // const dateRaw = local.slice(0, local.lastIndexOf(',')).split('/')
      // const dateFinal =
      //   dateRaw[2] +
      //   '-' +
      //   (dateRaw[1].length > 1 ? dateRaw[1] : '0' + dateRaw[1]) +
      //   '-' +
      //   (dateRaw[0].length > 1 ? dateRaw[0] : '0' + dateRaw[0])
      // const timeFinal = local
      //   .slice(local.lastIndexOf(' ') + 1)
      //   .replace(/\./g, ':')

      const newForm = {
        act: this.objForm.act,
        company_id: this.objForm.company.id,
        company_name: this.objForm.company.name,
        incident_location: this.objForm.incident_location,
        incident_location_id:
          this.objForm.incident_location != null
            ? this.objForm.incident_location.id
            : null,
        incident_location_name:
          this.objForm.incident_location != null
            ? this.objForm.incident_location.name
            : null,
        reported_date: this.objForm.reported_date,
        incident_date_time: this.objForm.incident_date_time,
        chronology: this.objForm.chronology,
        cause: this.objForm.cause,
        person_involve: []
      }

      console.log('this.objForm.person_involve>>>', this.objForm.person_involve)
      for (let i = 0; i < this.objForm.person_involve.length; i++) {
        console.log(
          'this.objForm.person_involve[i]',
          this.objForm.person_involve[i]
        )
        const obj = {
          name: this.objForm.person_involve[i].name,
          birth_date: this.objForm.person_involve[i].birth_date,
          gender: this.objForm.person_involve[i].gender.id,
          no_identitas: this.objForm.person_involve[i].no_identitas,
          person_type: this.objForm.person_involve[i].person_type.id,
          engagement_type: this.objForm.person_involve[i].engagement_type.id
        }
        if (this.objForm.person_involve[i].engagement_type.id === 1) {
          Object.assign(obj, {
            injured_category_id:
              this.objForm.person_involve[i].injured_category.id,
            injured_body_part_id:
              this.objForm.person_involve[i].injured_body_part_id,
            machine_used: this.objForm.person_involve[i].machine_used,
            rehabilitation_days:
              this.objForm.person_involve[i].rehabilitation_days,
            amount_loss: this.objForm.person_involve[i].amount_loss
          })

          if (this.objForm.person_involve[i].employee_leader != null) {
            Object.assign(obj, {
              employee_leader_id:
                this.objForm.person_involve[i].employee_leader.id,
              employee_leader_name:
                this.objForm.person_involve[i].employee_leader.name
            })
          }
          if (this.objForm.person_involve[i].person_type.id == 1) {
            Object.assign(obj, {
              company_id:
                this.objForm.person_involve[i].company != null
                  ? this.objForm.person_involve[i].company.id
                  : null,
              company_name:
                this.objForm.person_involve[i].company != null
                  ? this.objForm.person_involve[i].company.name
                  : null,
              department_id:
                this.objForm.person_involve[i].department != null
                  ? this.objForm.person_involve[i].department.id
                  : null,
              department_name:
                this.objForm.person_involve[i].department != null
                  ? this.objForm.person_involve[i].department.name
                  : null
            })
          }
        }
        xArryPerson.push(obj)
      }
      newForm.person_involve = xArryPerson
      // console.log('createNewForm', newForm)
      this.submitIncidentReport(newForm)
    },
    async submitIncidentReport(form) {
      this.loading = true
      await axios
        .post(`${this.dssApi}initialreport/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            // const created_id = res.data.created_id
            // console.log(created_id)
            // this.showMsgDialog('success', res.data.status_msg, false)
            this.closeIncidentReportDialog()
            this.$emit('loadPage')
            setTimeout(() => {
              window.open(
                `/dss/k3/incidentreport/detail/${res.data.created_id}`,
                '_blank'
              )
            }, 100)
            // setTimeout(() => {
            //   this.$router.push(`incidentreport/detail/${res.data.created_id}`)
            // }, 500)
            // }, 100)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async openPersonInvolveDialog() {
      setTimeout(() => {
        document.getElementById('personInvolveForm').click()
      }, 200)
    },
    savePersonInvolve(data) {
      // console.log('savePersonInvolve', data)
      if (data != null) {
        this.objForm.person_involve.push(data)
      }
      // this.$nextTick(() => {
      // console.log(this.$refs.personInvolveRef); // Safe to access here
      // console.log('savePersonInvolve>>2', this.$refs)
      //   this.$refs.personInvolveRef.closePersonInvolveDialog()
      // })
    },
    deletePersonInvolve(item) {
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
        .then((result) => {
          if (result.isConfirmed) {
            const index = this.objForm.person_involve.indexOf(item)
            if (index > -1) {
              this.objForm.person_involve.splice(index, 1)
            }
            this.$swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            )
          }
        })
    },
    getMinDate() {
      if (this.data != null) {
        const [year, month] = this.data.report_date.split('-').map(Number) // First date of the month
        const firstDate = new Date(year, month - 1, 1)

        const result = this.formatDateLocal(firstDate)
        return result
      }
      return null
    },
    getMaxDate() {
      if (this.data != null) {
        const [year, month] = this.data.report_date.split('-').map(Number) // First date of the month
        // Last date of the month: day 0 of the next month gives the last day of current month
        const lastDate = new Date(year, month, 0)
        const result = this.formatDateLocal(lastDate)
        return result
      }
      return null
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },

    formatDateLocal(date) {
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    getBodyPartName(obj) {
      const xFindBodyPart = this.dropdown.body_part.find((d) => d.id == obj)
      let xBodyPart = '-'
      if (xFindBodyPart != undefined) {
        xBodyPart = xFindBodyPart.name
      }

      return xBodyPart
    }
  }
}
</script>
